import { z } from "zod";
import { RentalVehicleType } from "../../../types/dtos/api/itinerary/itinerary-search-request.dto";
import { definePersistedSlice } from "../runtime/definePersistedSlice";

const rentalVehicleTypeSchema = z.enum( [
    RentalVehicleType.BICYCLE,
    RentalVehicleType.CARGO_BICYCLE,
    RentalVehicleType.MOPED,
    RentalVehicleType.SCOOTER_STANDING,
    RentalVehicleType.SCOOTER_SEATED,
    RentalVehicleType.CAR,
    RentalVehicleType.OTHER,
] );

/**
 * Zod schema for shared / rental vehicle type preferences.
 */
const RentalVehiclesPrefsSchema = z.object( {
    /** Enabled rental form factors; empty means shared vehicles are off for search. */
    "enabledTypes": z.array( rentalVehicleTypeSchema ).default( [] ),
} );

/** In-memory and persisted shape for rental vehicle preferences. */
export type RentalVehiclesPrefs = z.infer<typeof RentalVehiclesPrefsSchema>;

/** Parsed defaults used before hydration and as decode fallback. */
export const RENTAL_VEHICLES_PREFS_DEFAULT: RentalVehiclesPrefs = RentalVehiclesPrefsSchema.parse( {} );

/** Persisted slice: enabled rental vehicle form factors for itinerary search. */
export const rentalVehiclesPrefsSlice = definePersistedSlice<RentalVehiclesPrefs>( {
    "key":            "rentalVehiclesPrefs",
    "currentVersion": 1,
    "storage":        "preferences",
    "eager":          true,
    "schema":         RentalVehiclesPrefsSchema,
    "default":        () => RENTAL_VEHICLES_PREFS_DEFAULT,
    "migrations":     {},
} );
